jQuery(document).ready(function($) {
  if (!$('.section-side-contact').length) {
    return;
  }
  var contheight = $( '.section-side-contact__form' ).outerWidth() + 60;       
  $( '.section-side-contact' ).css( 'right', '-' + contheight + 'px' );
  // $( '.section-side-contact' ).css( 'visibility', 'visible' );

  $('.section-side-contact').addClass('open-form');
  $('.section-side-contact').addClass('bounce-in-up');

  var triggerPoint = $('.b-image-title-text').offset().top - $('.header').outerHeight() - 400;
  var contentHeight = $('.two-columns').offset().top - $('.header').outerHeight() - 400;
  $(window).scroll(function () {
    var scrollTop = $(this).scrollTop();
    if (scrollTop >= triggerPoint && scrollTop < contentHeight) {
      $('.section-side-contact').css( 'visibility', 'visible' );
    } else {
      $('.section-side-contact').css( 'visibility', 'hidden' );
    }
    
  //   console.log('scroll - ' + scrollTop);
  // console.log('triggerPoint - ' + triggerPoint);
  // console.log('contentHeight - ' + contentHeight);
  });

  
                    
  $( '.section-side-contact__title, .section-side-contact-close' ).click(function() {
      if($('.section-side-contact').hasClass('open'))
      {
          $('.section-side-contact').removeClass('open');
          $( '.section-side-contact' ).css( 'right', '-'+contheight+'px' );
          $( '.section-side-contact-close').hide();
      }
      else {
          $('.section-side-contact').addClass('open');
          $( '.section-side-contact' ).css( 'right', 0 );    
          $( '.section-side-contact-close').show();
      }
                      
  });
  
  
});


// WEBPACK FOOTER //
// ./scripts/blocks/contact-side.js